import { ValueOf } from '@/types/util';

export const EGrantStatus = {
  SCHEDULED: '付与予定',
  GRANTED: '付与済',
  SCHEDULE_CANCELED: '付与予定取消',
  GRANT_CANCELED: '付与取消',
  FAILURE: '付与失敗',
  FAILURE_CANCELED: '障害取消済',
} as const;

export type GrantStatusKey = keyof typeof EGrantStatus;
export type GrantStatusValue = ValueOf<typeof EGrantStatus>;

export const grantStatusKeys = Object.keys(EGrantStatus) as (GrantStatusKey[]);

/** v-select用items */
export const grantStatusItems = grantStatusKeys
  .map((key) => ({
    title: EGrantStatus[key],
    value: key,
  }));
